import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  data: {
    marginLeft: 10,
    maxWidth: 280,
    minWidth: 0,
    flex: 1,
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
  },
  specialty: {
    fontSize: '12px',
    maxWidth: '200px',
    minHeight: '16px',
    color: '#8B8E93',
    marginBottom: 0,
  },
}));
